<template>
<div class="chapter">
<div class="inner_page">
<div id="IS-EB-5P-2.html" xml:lang="en-US">
<div class="story">
<h1 id="toc_marker-2">
</h1></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// IS-EB5P-2.vue?b3971518